import { APIProvider } from '@vis.gl/react-google-maps'
import { WP_LOCALE } from '../../../../utils/algolia/algoliaLocalization'

export function MapsApiProvider({
  children,
  mapsApiKey
}: {
  children: React.ReactNode
  mapsApiKey: string
}) {
  return (
    <APIProvider
      apiKey={mapsApiKey}
      language={WP_LOCALE}
      authReferrerPolicy="origin"
    >
      {children}
    </APIProvider>
  )
}
